'use strict';

var angular = require('angular');
var FlightAnalysisReoptPopoverDirective = function FlightAnalysisReoptPopoverDirective() {
  return {
    restrict: 'E',
    replace: true,
    template: require('../templates/grid-flight-analysis-reopt-popover.html'),
    link: function link($scope) {
      $scope.dropDownClicked = function (e) {
        e.stopPropagation();
        if (angular.element(e.target).hasClass('cancel-drop-down')) {
          angular.element('.toolbar-dropdown-menu').parent().removeClass('open');
        }
      };
    }
  };
};
FlightAnalysisReoptPopoverDirective.$inject = [];
module.exports = FlightAnalysisReoptPopoverDirective;